module.exports = "<app-header></app-header>\r\n<div class=\"container-fluid\">\r\n    <ng-content></ng-content>\r\n</div>\r\n<app-footer></app-footer>"